export const parseOrderedTeamNames = (isTeamSwap, participants) => {
    let [home, away] = participants;
    if (isTeamSwap) {
        [away, home] = participants;
    }
    return {
        team1Name: home.name,
        team2Name: away.name
    };
};
//# sourceMappingURL=parseOrderedTeamNames.js.map